var React = require('react');

function NigeriaLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.5 0H0.5C0.223858 0 0 0.223858 0 0.5V14C0 14.2761 0.223858 14.5 0.500001 14.5H20.5C20.7761 14.5 21 14.2761 21 14V0.5C21 0.223858 20.7761 0 20.5 0Z","fill":"#008751","key":0}),React.createElement("path",{"d":"M14 0H7V14.5H14V0Z","fill":"white","key":1})]);
}

NigeriaLogo.defaultProps = {"width":"21","height":"15","viewBox":"0 0 21 15","fill":"none"};

module.exports = NigeriaLogo;

NigeriaLogo.default = NigeriaLogo;
